import React, { memo, useCallback, useEffect } from 'react';

import { CloseOutlined } from '@ant-design/icons';

import useScrollBlock from './hook';

interface IProps {
  open: boolean;
  onClose: () => void;
  title: string | JSX.Element;
  children: React.ReactNode;
}

const QuickView = memo(({ open, onClose, title, children }: IProps) => {
  const [blockScroll, allowScroll] = useScrollBlock();

  const handleClose = useCallback(() => {
    onClose();
  }, [onClose]);

  useEffect(() => {
    if (open) {
      return blockScroll();
    }

    allowScroll();

    return () => allowScroll();
  }, [open, blockScroll, allowScroll]);

  return (
    <>
      {open && <div className='fixed top-0 left-0 z-105 h-full w-full bg-black/50' onClick={() => handleClose()} />}

      <div
        className={`fixed top-0 z-107 h-full w-[450px] max-w-full overflow-auto bg-white transition-[right] duration-200 ease-linear ${
          open ? 'right-0' : '-right-[500px]'
        }`}
      >
        {open && (
          <>
            <div className='flex h-[50px] items-center justify-between border-b border-[#d9d9d9] font-semibold'>
              <div className='w-[calc(100%-58px)] px-4'>{title}</div>

              <div
                className='ml-2 flex h-[50px] w-[50px] cursor-pointer items-center justify-center'
                onClick={() => handleClose()}
              >
                <CloseOutlined />
              </div>
            </div>

            <div className='w-full p-4'>
              <div>{children}</div>
            </div>
          </>
        )}
      </div>
    </>
  );
});

export default QuickView;
